import { RouteObject } from "react-router-dom";
import { NotFound } from "src/routes/NotFound";
import { BidItemPage } from "src/routes/libraries/item-catalog/BidItemPage";
import { ItemCatalogPage } from "src/routes/libraries/item-catalog/ItemCatalogPage";
import { AppShell } from "src/routing/components/AppShell";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import { ScrollableParentLayout } from "src/routing/components/layouts/ScrollableParentLayout";
import * as itemCatalogPaths from "src/routing/domains/libraries/item-catalog/itemCatalogPaths";

/**
 * `/libraries/item-catalog/*` route tree.
 *
 * Role: data router domain route.
 *
 * Stack: `AppShell` → `GlobalNavLayout` → `ScrollableParentLayout` → page (legacy `PageHeader` chrome).
 */
export const itemCatalogRoutes: RouteObject = {
  path: itemCatalogPaths.itemCatalogRoute.path,
  Component: AppShell,
  children: [
    {
      Component: GlobalNavLayout,
      children: [
        {
          Component: ScrollableParentLayout,
          children: [
            { index: true, Component: ItemCatalogPage },
            { path: itemCatalogPaths.bidItemCreateRoute.path, Component: BidItemPage },
            { path: itemCatalogPaths.bidItemDetailsRoute.path, Component: ItemCatalogPage },
          ],
        },
      ],
    },
    { path: "*", Component: NotFound },
  ],
};
